module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahead3-6b94fa7c3db7ff1bd1bd406a144fc1b6.jpg";